<script>
    import {network, store} from '../../stores.js';
    import ButtonConfirm from '../form/Button.svelte';
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher();

    const axis = store('axis', '', false);
    const user = store('credential', 'getAuth');
    const cart = store('cart-items', '', '[]');

    export let args;

    const add_item = async () => {
        let id = args.id ? args.id : null;
        let item = Object.assign({}, args.item);

        let popup;
        let data = ($cart || []);
        let index = id ? data.findIndex((el) => el.idTovar === id) : null;

        switch (true) {
            // изменение количества
            case !$axis && id !== null && data[index] && item.quantity !== data[index].quantity: {
                item.idTovar = id; // kostil
                data[index] = item;

                popup = new bootstrap.Modal(document.getElementById('item-update'));
                break;
            }

            // изменение товара
            case id !== null: {
                // здесь товар который редактировался - удаляется из корзины
                data = data.filter((el) => el.idTovar !== id);

                // Доставка и покраска уже ссылаются на общую карточку.
                // correctTovar с id строки продажи затирал ею чужой материал.
                if (!item.idTovar) {
                    item.idTovar = await network.update({...item, idTovar: id});
                }

                data.push(item);

                popup = new bootstrap.Modal(document.getElementById('item-upgrade'));
                break;
            }

            // создание товара
            default: {
                if (!item.idTovar) {
                    item.idTovar = await network.create(item, args.calc);
                }

                data.push({...item, calc: args.calc});

                popup = new bootstrap.Modal(document.getElementById('item-add'));
                break;
            }
        }

        if (!$axis) { popup.show(); }

        // выход из редактирования
        id = null;
        dispatch('reset');
        document.body.dispatchEvent(new CustomEvent('reset', {}));

        if ($axis) {
            let params = {
                calc: args.calc,
                idTovar: item.idTovar,
                name: item.title,
                artikul: item.comment,
                ind1: item.params.ind1,
                ind2: item.params.ind2,
                ind3: item.params.ind3,
                kolvo: item.quantity,
                maxkolvo: item.quantity,
                // ильшат здесь абстрагируется от слов и реальности. xDDD
                summa: item.price.rozn / item.quantity,
                summaRozn: item.price.rozn / item.quantity,
                summaDil: item.price.opt / item.quantity,
                sebestoim: item.price.sebest / item.quantity,

                vStrukture: 11,
            };

            window.top.postMessage('add_item::' + JSON.stringify(params), '*');
        } else {
            cart.save(data);

            setTimeout(() => {
                popup.hide();
                document.querySelector('[data-bs-target="#cartPanel"]').click();
            }, 1500);
        }
    };
</script>

{#if (args.item && args.item.quantity || args.id) && (Object.keys(args.item.materials).length || args.item.idTovar) }
    <div class="card-body">
        <div class="row text-center d-flex justify-content-center">
            <div class="col-4 pb-2">
                <span class="d-inline d-md-none"><b>Стоим.</b>:<br></span>
                <span class="d-none d-md-inline"><b>Стоимость</b>:<br></span>
                {#if args.item.quantity > 1}
                    {(args.item.price.rozn / args.item.quantity).toLocaleString()}₽
                    &times;
                    {args.item.quantity}шт
                    =
                {/if}
                {(+args.item.price.rozn).toLocaleString()}₽
            </div>
        </div>

        <ButtonConfirm add_item={add_item} id={args.id} errors={args.errors} />
    </div>
{/if}
